import React, { useState, useRef } from "react";
import axios from "axios";
// import DisplayCarousel from "./DisplayCarousel";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const UploadImages = (props) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const enrollId = props.id;  

  const fileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage("Please select a file.");
      return;
    }
    
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("enrollment_id", enrollId);
    formData.append("type", "student-resource");

    try {
      await axios.post(`${API_BASE_URL}/api/image-upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage("Upload successful!");
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      setMessage("Upload failed: " + (err.response?.data?.message || err.message));
    }
    setLoading(false);
  };

  return (
    <>
      <form className="space-y-4 bg-base-200 p-8 rounded-xl shadow-md max-w-md mx-auto" onSubmit={handleSubmit}>
        {/* File Input */}
        <label className="form-control w-full">
          <div className="label">
            <span className="label-text">Select File</span>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            className="file-input file-input-bordered w-full"
            onChange={e => {
              setFile(e.target.files[0]);
              setMessage("");
            }}
            disabled={loading}
          />
        </label>
        
        {/* Submit Button */}
        <button className="btn btn-primary w-full" type="submit" disabled={loading}>
          {loading ? (
            <span>
              <span className="loading loading-spinner loading-sm mr-2"></span> Uploading...
            </span>
          ) : (
            "Upload File"
          )}
        </button>
        
        {message && (
          <div className={`text-center ${message.includes("success") ? "text-success" : "text-error"}`}>
            {message}
          </div>
        )}
      </form>
      <hr/>
      {/* <DisplayCarousel /> */}
    </>
  );
};

export default UploadImages;